/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

/**
 * @param endpoint
 * @param params
 * @param query
 * @returns {string}
 */
export const prepare = function (
    endpoint: string,
    params: {[key: string]: string | number} = {},
    query: {[key: string]: string | number | boolean | string[]} = {},
): string {
    let preparedEndpoint = endpoint;
    query = JSON.parse(JSON.stringify(query));
    Object.keys(params).forEach((param) => {
        const paramPlaceholder = `{${param}}`;
        if (preparedEndpoint.includes(paramPlaceholder)) {
            let paramValue = params[param];
            if (typeof paramValue === 'number') {
                paramValue = paramValue.toString();
            }
            preparedEndpoint = preparedEndpoint.replace(
                paramPlaceholder,
                paramValue,
            );
        } else {
            // eslint-disable-next-line no-console
            console.error('Invalid parameter.');
        }
    });
    let preparedQueryString = '?';
    const queryKeys = Object.keys(query);
    queryKeys.forEach((queryKey, index) => {
        if (index !== 0) {
            preparedQueryString += '&';
        }
        const queryValue = query[queryKey];
        if (Array.isArray(queryValue)) {
            queryValue.forEach((queryValueItem, itemIndex) => {
                if (itemIndex !== 0) {
                    preparedQueryString += '&';
                }
                preparedQueryString += `${queryKey}[]=${queryValueItem}`;
            });
        } else {
            preparedQueryString += `${queryKey}=${queryValue}`;
        }
    });
    return encodeURI(
        preparedEndpoint + (queryKeys.length === 0 ? '' : preparedQueryString),
    );
};

/**
 * @param endpoint
 * @param params
 * @param query
 * @returns {string}
 */
export const urlFor = function (
    endpoint: string,
    params: {[key: string]: string | number} = {},
    query: {[key: string]: string | number | boolean | string[]} = {},
): string {
    // @ts-expect-error: appGlobal is not in window object by default
    return window.appGlobal.baseUrl + prepare(endpoint, params, query);
};
